import { render, staticRenderFns } from "./TabelaCadastrarContratoOriginacao.vue?vue&type=template&id=08525ee5&lang=pug"
import script from "./TabelaCadastrarContratoOriginacao.vue?vue&type=script&lang=js"
export * from "./TabelaCadastrarContratoOriginacao.vue?vue&type=script&lang=js"
import style0 from "./TabelaCadastrarContratoOriginacao.vue?vue&type=style&index=0&id=08525ee5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports